import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { AuthService } from '../service/authService';

@Injectable()
export class HttpJwtInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Prevent interceptor from interfering with unprotected routes
        const isApiUrl = request.url.startsWith(environment.apiHost + "/api");

        // add auth header with jwt if user is logged in and request is to api urls
        if (this.authService.token && isApiUrl && !request.url.endsWith("/api/v1/user/auth")) {
            request = request.clone({
                setHeaders: {
                    "Authorization": `Bearer ${this.authService.token}`,
                }
            });
        }

        return next.handle(request);
    }
}
